export default {
  journalTableFilter: '',
};
